import { render, staticRenderFns } from "./CurrentPortfolioAccountBreakdownArea.vue?vue&type=template&id=62b9e8c2&scoped=true&"
import script from "./CurrentPortfolioAccountBreakdownArea.vue?vue&type=script&lang=js&"
export * from "./CurrentPortfolioAccountBreakdownArea.vue?vue&type=script&lang=js&"
import style0 from "./CurrentPortfolioAccountBreakdownArea.vue?vue&type=style&index=0&id=62b9e8c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b9e8c2",
  null
  
)

export default component.exports